import React, {useState} from "react";
import Rating from "@mui/material/Rating";
import axios from "axios";
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

const SupportFeedback = () => {
  const params = useParams();
  const id = params.id;
  const [message, setMessage] = useState('');
  const [rating, setRating] = useState(0);

  // Snackbar state
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');

  const feedbackForm = async () => {
    const data = new FormData();
    data.append("review", message);
    data.append("rating", rating);
    data.append("id", id);

    try {
      const res = await axios.post(
        ENDPOINT + `submit-customer-support-review.php`,
        data,
        SecurityHeaders,
      );
      if (res && res.data && res.data.status === "success") {
        setSnackbarMsg("Feedback submitted successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setMessage('');
        setRating(0);
      } else {
        setSnackbarMsg("Something went wrong. Try again later.");
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
      }
    } catch (error) {
      setSnackbarMsg("Something went wrong. Try again later.");
      setSnackbarSeverity("error");
      setSnackbarOpen(true);
    }
  };

  return (
    <div>
      <div className="container  p-0 d-flex justify-content-center py-5">
        <div className="col-lg-5 col-md-8 shadow col-sm-10 col-12 border border-0 border-md-1 rounded p-3  ">
          <h2 className="text-center mb-4 mt-2">Feedback Form</h2>
          <form onSubmit={(e)=>{e.preventDefault();feedbackForm();}}>
            <div className="mb-3">
              <label className="form-label">Feedback</label>
              <textarea
                className="form-control min-vh-20"
                name="Enter your feedback"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder="Please describe your feedback..."
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Rating *</label>
              <div className="rating">
                <Rating
                  name="simple-controlled"
                  value={rating}
                  onChange={(event, newValue) => {
                    setRating(newValue);
                  }}
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn btn-primary w-100"
            >
              Submit Feedback
            </button>
          </form>
        </div>
      </div>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setSnackbarOpen(false)} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMsg}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SupportFeedback;
